import embeddedQualifiedTestTemplate from './embedded-qualified-test.tpl.html';
import embeddedQualifiedOptionsTemplate from './embedded-qualified-options.tpl.html';
import './embedded-qualified-test.less';
import { remove } from '../../../../shared/app/utils/array-utils';
import { appConfig } from '../../../../shared/app/constants/app-config';
import { markdownComponentModule } from '../../../../shared/app/components/markdown/markdown';
import {
  ADVANCED_CODE_CHALLENGE_TYPE,
  CODE_CHALLENGE_TYPE,
  TYPE_KEYS,
} from '../../../../shared/app/models/challenge';
import { identity } from '../../../../shared/app/utils/function-utils';

let demoChallenges = [];

export const EMBED_THEMES = [
  {
    v: 'light',
    l: 'Force Light Theme ("light")',
  },
  {
    v: 'dark',
    l: 'Force Dark Theme ("dark")',
  },
];
export const EMBED_MODES = [
  {
    v: 'restricted',
    l: 'Restricted (can edit, but nothing saves) ("restricted")',
  },
  {
    v: 'readonly',
    l: 'Read-Only ("readonly")',
  },
];
export const EMBED_ACTIONS = [
  {
    v: true,
    l: 'Hide all actions in the editor, use external actions or shortcut keys to run. (true)',
  },
  {
    v: 'attempt',
    l: 'Hide the SUBMIT action in the editor, only enable run tests. ("attempt")',
  },
  {
    v: 'runTests',
    l: 'Hide the RUN TESTS action in the editor, only enable submit. ("runTests")',
  },
];

export const embeddedQualifiedTestComponentModule = angular
  .module('Q.components.embedded-qualified-test', [markdownComponentModule])

  .component('embeddedQualifiedTest', {
    bindings: {
      hideAuth: '<',
      noDefaults: '<',
      demoChallenges: '<',
      disableAdd: '<',
      challengeIds: '<?',
      managerOptions: '<?',
      embeds: '=?',
    },
    controller: 'EmbeddedQualifiedTestCtrl',
    template: embeddedQualifiedTestTemplate,
  })

  .controller(
    'EmbeddedQualifiedTestCtrl',
    function EmbeddedQualifiedTestCtrl($scope, $window, $http) {
      const ctrl = this;

      const embedClientKey = '6CmpVAhdeGKw/Fmz7noB+qP8o+Xvb9b8';

      function syntaxHighlight(json) {
        json = JSON.stringify(json, null, 2);
        json = json
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        return json.replace(
          /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
          function (match) {
            let cls = 'hljs-literal';
            if (/^"/.test(match)) {
              if (/:$/.test(match)) {
                cls = 'hljs-title';
              } else {
                cls = 'hljs-string';
              }
            } else if (/true|false|null/.test(match)) {
              cls = 'hljs-keyword';
            }
            return '<span class="' + cls + '">' + match + '</span>';
          },
        );
      }

      let embedId = 0;
      const makeEmbed = (props) => {
        const e = {};
        angular.merge(
          e,
          {
            embedId: ++embedId,
            tabs: [],
            toggleTab(tab) {
              const tabs = (this.opts.hideTabs || '')
                .split(',')
                .filter((a) => a);
              if (tabs.includes(tab)) {
                remove(tabs, tab);
              } else {
                tabs.push(tab);
              }
              this.opts.hideTabs = tabs.join(',');
            },
            loadData:
              '<span class="hljs-comment">// Info about the loaded challenge shown here</span>',
            files:
              '<span class="hljs-comment">// File contents will be shown here once loaded</span>',
            results:
              '<span class="hljs-comment">// Run results will be shown after running code</span>',
            opts: {
              onLoaded({ data }) {
                e.error = data.error;
                e.loaded = !data.error;
                if (!e.example) {
                  e.label = data.title;
                  if (data.summary) {
                    e.description = data.summary;
                  }
                }
                e.languages = data.languages;
                if (data.solutionLanguage) {
                  e.opts.language = data.solutionLanguage;
                } else if (data.languages && data.languages.length === 1) {
                  e.opts.language = data.languages[0];
                }
                e.tabs = data.availableTabs;
                e.started = data.started;
                e.loadData = syntaxHighlight(data);
                e.isAdvanced = data.type === ADVANCED_CODE_CHALLENGE_TYPE;
                e.isCode = e.isAdvanced || data.type === CODE_CHALLENGE_TYPE;
                e.icon = 'icon-' + TYPE_KEYS[data.type];
                $scope.$applyAsync();
              },
              onChange({ data }) {
                e.files = syntaxHighlight(data);
                $scope.$applyAsync();
              },
              onRun({ data }) {
                e.results = syntaxHighlight(data);
                $scope.$applyAsync();
              },
              initialLayout: {
                topLeft: [],
                topRight: [],
                bottomLeft: [],
                bottomRight: [],
              },
            },
          },
          props,
        );
        return e;
      };

      ctrl.$onInit = () => {
        let embeds = [];
        if (Array.isArray(ctrl.challengeIds)) {
          embeds = ctrl.challengeIds.map((id) => makeEmbed({ id }));
        } else if (!ctrl.noDefaults) {
          embeds = [
            makeEmbed({
              id: '58e6576a7e68c90014a0279e',
              label: 'Classic Code',
              example: true,
              description:
                'This example shows a classic code challenge, using mostly the default configuration. Click on _Show Embed Configuration_ to see how changing the default configuration changes the embed.',
              opts: {
                language: 'javascript',
              },
            }),
            makeEmbed({
              id: '5d3f62af4d8eb0000e063d4d',
              label: 'Web Preview',
              example: true,
              description:
                'Shows using a project challenge with embedded web preview, no code running, and dark mode.',
              opts: {
                theme: 'dark',
                hideTabs:
                  'instructions,runnerframe,idesettings,__tests__/Checkbox.test.jsx,public/index.html',
                initialLayout: {
                  topLeft: [],
                  topRight: [],
                  bottomLeft: [],
                  bottomRight: ['webpreviewconsole'],
                },
              },
            }),
          ];
        }
        ctrl.embeds = embeds;

        const options = ctrl.managerOptions || {};
        options.baseURL = $window.location.origin;

        // Since there have been regressions due to using the old version, try
        // using both embed init APIs for the time being so we're sure it works.
        if ($window.QualifiedEmbed.QualifiedEmbedManager) {
          // new API
          ctrl.manager = $window.QualifiedEmbed.QualifiedEmbedManager.init({
            options: { ...options, embedClientKey },
          });
        } else {
          // old API
          ctrl.manager = $window.QualifiedEmbed.init({
            options: { ...options, embedClientKey },
          });
        }

        ctrl.initEmbed = (node, challengeId, options) => {
          return ctrl.manager.createEditor({
            node,
            challengeId,
            options: { ...options, embedClientKey },
          });
        };

        ctrl.destroy = (index) => {
          ctrl.embeds.splice(index, 1);
        };

        ctrl.showAdd = () => {
          ctrl.newEmbed = makeEmbed({});
        };
        ctrl.add = () => {
          if (ctrl.embeds.find((e) => e.id === ctrl.newEmbed.id)) {
            $window.alert(
              'Already showing that challenge, please choose a different one',
            );
          } else {
            ctrl.embeds.push(ctrl.newEmbed);
            ctrl.newEmbed = null;
          }
        };

        if (ctrl.demoChallenges || ctrl.noDefaults) {
          demoChallenges = ctrl.demoChallenges || [];
        } else {
          $http
            .get(appConfig.apiRoot + 'challenges/embed_demos')
            .then((result) => {
              if (result && result.data) {
                demoChallenges = result.data.data;
              }
            });
        }
      };
    },
  )

  .component('embeddedQualifiedOptions', {
    restrict: 'E',
    bindings: {
      embed: '<',
      expanded: '<?',
      onSubmit: '&',
      addMode: '<?',
      managerOptions: '<',
    },
    template: embeddedQualifiedOptionsTemplate,
    controller: /* @ngInject*/ function () {
      const ctrl = this;
      Object.defineProperty(ctrl, 'demos', {
        get: () => demoChallenges,
      });

      ctrl.themes = EMBED_THEMES;
      ctrl.modes = EMBED_MODES;
      ctrl.actions = EMBED_ACTIONS;

      let previousId;
      ctrl.updateDemoId = () => {
        if (ctrl.demo) {
          ctrl.embed.id = previousId = ctrl.demo.id;
          if (ctrl.demo.languages) {
            ctrl.embed.languages = ctrl.demo.languages;
          }
          ctrl.embed.label = ctrl.demo.title;
        } else if (previousId === ctrl.embed.id) {
          ctrl.embed.id = '';
          if (ctrl.editor && ctrl.editor.challengeData) {
            ctrl.embed.languages = ctrl.editor.challengeData.languages;
          } else {
            ctrl.embed.languages = [];
          }
        }
      };

      ctrl.tabsets = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];
      ctrl.updateLayout = (ts) => {
        ctrl.embed.opts.initialLayout[ts] = ctrl.initialLayout[ts]
          .split(',')
          .filter(identity);
      };

      ctrl.$onInit = () => {
        const demo = ctrl.demos.find((d) => d.id === ctrl.embed.id);
        if (demo) {
          ctrl.demo = demo;
          ctrl.previousId = ctrl.embed.id;
        }
        ctrl.initialLayout = {};
        ctrl.tabsets.forEach((ts) => {
          ctrl.initialLayout[ts] = ctrl.embed.opts.initialLayout[ts].join(',');
        });
      };
    },
  })

  .directive('qualifiedEmbed', function () {
    return {
      restrict: 'A',
      require: '^embeddedQualifiedTest',
      link(scope, elem, attrs, embeddedQualifiedTestCtrl) {
        const embed = scope.embed;
        const editor = (scope.editor = embeddedQualifiedTestCtrl.initEmbed(
          elem[0],
          embed.id,
          embed.opts,
        ));
        embed.editor = editor;

        function updateInternalProps() {
          embed.readOnly = editor.options.mode === 'readonly';
          embed.restricted =
            embed.readOnly || editor.options.mode === 'restricted';
        }

        updateInternalProps();

        scope.update = () => {
          editor.update({ challengeId: embed.id, options: embed.opts });
          updateInternalProps();
        };

        scope.$on('$destroy', () => {
          if (editor) {
            editor.destroy();
          }
        });
      },
    };
  });
